module.exports = __webpack_public_path__ + "static/media/002-bird.abaf030b.svg";